
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"47","height":"47","viewBox":"0 0 36.521 36.521"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1147","transform":"translate(-995 -94.204)"}},[_c('circle',{attrs:{"data-name":"Ellipse 62","cx":"18.26","cy":"18.26","r":"18.26","transform":"translate(995 94.204)","fill":"#fff"}}),_c('g',{attrs:{"data-name":"Group 656"}},[_c('g',{attrs:{"data-name":"Path 749"}},[_c('path',{attrs:{"data-name":"Path 751","d":"M1021.054 121.07a1.239 1.239 0 01-.88.362 1.212 1.212 0 01-.887-.357l-6.359-6.36-6.359 6.36a1.263 1.263 0 01-1.767-.007 1.238 1.238 0 01-.362-.88 1.212 1.212 0 01.357-.886l6.358-6.358-6.36-6.36a1.256 1.256 0 01.881-2.135 1.306 1.306 0 01.893.363l6.359 6.36 6.353-6.354a1.222 1.222 0 01.9-.372 1.238 1.238 0 01.878.365 1.267 1.267 0 01-.005 1.78l-6.353 6.352 6.36 6.36a1.269 1.269 0 01-.007 1.766z","fill":"#6d66a2"}})])])])])
          )
        }
      }
    